module.exports = __webpack_public_path__ + "media/images/shop/kodawari3-38929b44415093e4c1bf3c1e34558167.jpg";